import { ICommonLink } from '@src/models/common';

export const STORE: ICommonLink = {
  id: 'storeLink',
  disableNextJs: true,
  href: '/store',
  name: 'Витрина',
  icon: 'fire',
  authIcon: 'showcase',
  tags: ['role.agency-primary-manager', 'role.agency-manager', 'role.client-manager', 'role.client-primary-manager'],
};

export const STORE_PRODUCT: ICommonLink = {
  id: 'storeProductLink',
  disableNextJs: true,
  href: '/store/product',
  name: 'Витрина',
  icon: 'fire',
  authIcon: 'showcase',
  tags: ['role.agency-primary-manager', 'role.agency-manager', 'role.client-manager', 'role.client-primary-manager'],
};
